module.exports = __webpack_public_path__ + "img/disabal.0cbff1b4.svg";